<script>
import {ref, watch} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import Swals from "@/assets/js/Swals";
import $ from "jquery";
import swal from "sweetalert2";
import useClipboard from "vue-clipboard3";

export default {
  name: "EmergencyNumbers",
  components: {LoadingPage},
  setup() {
    let loading = ref(false)
    let phones = ref([])
    let dialog = ref(false)

    let all_phones = ref([])
    let text_search = ref('')

    let add_phone = ref({
      type: 'user',
      action: 'add',
      title: '',
      phone: '',
    })

    watch(() => text_search.value, () => {

      phones.value = []

      all_phones.value.forEach((item) => {

        if (item.title.includes(text_search.value) || item.phone.includes(text_search.value)) {
          phones.value.push(item)
        }

      })

    })

    function get_phone() {
      loading.value = true
      FreeWorld.Heisenberg({action: 'show'}, 'necessary_phone').then((res) => {

        loading.value = false
        phones.value = res.data
        all_phones.value = res.data

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_phone)
      })
    }
    get_phone()

    function open_dialog() {
      let div_dialog = $('#dialog')

      if (dialog.value) {
        div_dialog.removeClass('animate__fadeIn').addClass('animate__fadeOut')
        setTimeout(() => {
          dialog.value = false
          add_phone.value = {
            type: 'user',
            action: 'add',
            title: '',
            phone: '',
          }
        }, 700)
      } else {
        div_dialog.removeClass('animate__fadeOut').addClass('animate__fadeIn')
        dialog.value = true
      }
    }

    function add_new_phone() {
      if (add_phone.value.title.trim().length === 0) {
        Swals.Warning('لطفا عنوان شماره اضطراری را وارد کنید!');
        return false
      }
      if (add_phone.value.phone.length === 0) {
        Swals.Warning('لطفا شماره اضطراری را وارد کنید!');
        return false
      }

      loading.value = true
      FreeWorld.Heisenberg(add_phone.value, 'necessary_phone', true).then((res) => {
        loading.value = false
        if (res.data.status === 'ok') {
          Swals.Done('شماره مورد نظر شما با موفقیت ثبت شد')
          get_phone()
        } else if (res.data.status === 'error_phone') {
          Swals.Fault('شماره مورد نظر شما از قبل ثبت شده است!')
        } else {
          Swals.Fault('متاسفانه شماره مورد نظر شما ثبت نشد!')
        }
        open_dialog()
      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, add_new_phone)
      })
    }

    const {toClipboard} = useClipboard()
    function copy_phone(phone) {
      swal.fire({
        title: 'شماره همراه:',
        text: phone,
        confirmButtonText: 'کپی کردن',
      }).then((res) => {
        if (res.isConfirmed) {
          try {
            toClipboard(phone)
            Swals.Done('شماره همراه کپی شد')
          } catch (e) {
            Swals.Fault('شماره همراه کپی نشد!')
          }
        }
      })
    }


    return {
      loading,
      phones,
      open_dialog,
      dialog,
      add_phone,
      add_new_phone,
      text_search,
      copy_phone,
    }
  }
}
</script>

<template>
  <LoadingPage v-if="loading"></LoadingPage>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div v-if="dialog" @click="open_dialog" class="bg_dialog"></div>
    <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog px-3">
      <div class="rounded-4 bg-white p-3">
        <div class="position-relative">
          <p class="font-4 text-color font-bold text-center">ثبت شماره تماس</p>
          <img @click="open_dialog" class="icon-size-4 position-absolute top-0 start-0"
               src="../assets/img/icon-closeBgColor.svg" alt="">
        </div>

        <hr>
        <p class="font-4 text-color font-bold mb-2">عنوان شماره</p>
        <input v-model="add_phone.title" class="p-3 w-100 bg-custom rounded-pill shadow-custom mb-4 text-center"
               type="text">

        <p class="font-4 text-color font-bold mb-2">شماره تماس</p>
        <input v-model="add_phone.phone" class="p-3 w-100 bg-custom rounded-pill shadow-custom mb-5 text-center"
               type="tel">

        <div class="d-flex justify-content-center">
          <p @click="add_new_phone"
             class="font-4 font-bold text-center rounded-pill bg-color-liner text-white p-3 w-35">ثبت</p>
        </div>
      </div>
    </div>

    <div style="height: 5rem" class="d-flex align-items-center p-4">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg"
           alt="">
      <p class="text-white font-bold font-4">شماره های اضطراری</p>
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">

      <input v-model="text_search" class="p-3 rounded-pill shadow-custom w-100 mb-4"
             placeholder="به دنبال چه شماره ای هستی؟">

      <div v-if="phones.length === 0"
           class="animate__animated animate__fadeIn w-100 h-50 d-flex justify-content-center">
        <div class="d-flex flex-column justify-content-center align-items-center">
          <img style="width: 10rem" src="../assets/img/icon-recruitment.svg" alt="" class="mb-4">
          <p class="font-4 text-center">آیتمی وجود ندارد...!</p>
        </div>
      </div>

      <div v-else class="d-flex flex-wrap">
        <div v-for="item in phones" :key="item.id" class="animate__animated animate__fadeIn items p-3">
          <div @click="copy_phone(item.phone)" class="position-relative bg-white shadow-custom p-3 rounded-4">
            <div class="overflow-hidden w-90 title-phone position-absolute px-3 py-2 rounded-pill text-color text-center bg-color-light">
              <p class="font-6 text-center" :class="{'txtoverflow':item.title.length >= 10}">{{ item.title }}</p>
            </div>

            <div class="overflow-hidden">
              <p class="font-5 text-color mt-3 text-center" :class="{'txtoverflow':item.phone.length >= 8}">{{ item.phone }}</p>
            </div>
          </div>
        </div>
      </div>


      <div @click="open_dialog" class="position-fixed bottom-5 d-flex flex-column align-items-center me-3">
        <img class="icon-size-6 mb-3" src="../assets/img/icon-add.svg" alt="">
        <p class="font-5 text-color font-bold">شماره اضطراری</p>
      </div>
    </div>
  </div>

</template>

<style scoped>
.items {
  flex-grow: 0;
  flex-basis: 33.3%;
  max-width: 33.3%;
}

.title-phone {
  top: -1rem;
  left: 50%;
  transform: translate(-50%, 0);
  white-space: nowrap;
}
</style>